import React from "react";
import SynchToggle from "./SynchToggle";
import { useMultiuserContext } from "@solidwhite/multiuser";
import CursorToggle from "./CursorToggle";
import { ThemeProvider } from "@mui/material";
import { enrxTheme } from "../../ui/MuiTheme";

const PresentatorMenu = ({ ...props }) => {
  const { presenting } = useMultiuserContext();
  return (
    <ThemeProvider theme={enrxTheme}>
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
        }}
      >
        <SynchToggle />
        {presenting && <CursorToggle />}
      </div>
    </ThemeProvider>
  );
};

export default PresentatorMenu;
